<div class="mt-20 animate__animated animate__fadeIn">
    <app-banner [data]="data" [dataFeatures]="dataFeatures" [type]="'header'">
    </app-banner>
    <app-features class="hidden md:flex" [dataCat]="data" [dataFeatures]="dataFeatures" [type]="'catalogs'">
    </app-features>
    <app-carousel class="flex md:hidden" [dataCat]="data" [dataFeatures]="dataFeatures" [type]="'catalogs_mobile'">
    </app-carousel>
    <app-features [data]="data" [type]="'access_brands'"></app-features>
    <app-features [data]="dataFeatures" [type]="'products'" class="flex flex-col px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-20 2xl:px-32"></app-features>
    <br> <br> <br><br>
</div>